module.exports = __webpack_public_path__ + "609ccaab0e7efd5398bc86207bfc5436.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/assets/images/logo.png
 ** module id = 32
 ** module chunks = 0
 **/